import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useRef } from "react";
import { useStoreon } from "storeon/react";
import { DialogContextProps } from "@interfaces/System/DialogContextProps";
import { cartService } from "@services";
import { TableEvents, TableState } from "@store/table-module";
import { ModalContentLoading } from "../../Common/Modal";
import { Cart } from "@interfaces/Cart";
import { useAsync } from "@hooks";
import { CreateCartDto, UpdateCartDto } from "@dto/CartDto";
import { CreateCartForm, UpdateCartForm } from "@components/Forms/Cart";

const CartDialogContext = ({ onClose, modalProps }: DialogContextProps) => {
    const { itemId } = { ...modalProps };

    const formRef = useRef<any>(); // ref to formik
    const { enqueueSnackbar } = useSnackbar();
    const { dispatch } = useStoreon<TableState, TableEvents>();

    const { data: cart, loadingStatus } = useAsync<Cart>(cartService.getOneCart, {
        functionArgs: [itemId],
        canLoad: !!itemId,
    });

    const invokeSubmit = () => {
        formRef.current.handleSubmit();
    };

    const handleCreateCart = async (values) => {
        try {
            const dto = cartService.plainToClass(CreateCartDto, values);
            await cartService.createCart(dto);
            enqueueSnackbar("Корзина успешно создана", {
                variant: "success",
            });
            onClose();
            dispatch("table/update/data");
        } catch (err) {
            enqueueSnackbar("Произошла ошибка при создании корзины", {
                variant: "error",
            });
        }
    };

    const handleUpdateCart = async (values) => {
        if (!itemId) return;
        try {
            const dto = cartService.plainToClass(UpdateCartDto, values);
            await cartService.updateCart(itemId, dto);

            enqueueSnackbar("Корзина успешно обновлена", {
                variant: "success",
            });
            onClose();
            dispatch("table/update/data");
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при обновлении корзины", {
                variant: "error",
            });
        }
    };

    return (
        <>
            <DialogContent>
                {loadingStatus === "loading" && <ModalContentLoading />}

                {loadingStatus === "inactivity" && !itemId && (
                    <CreateCartForm ref={formRef} onSubmit={handleCreateCart} />
                )}

                {loadingStatus === "loaded" && itemId && cart && (
                    <UpdateCartForm data={cart} onSubmit={handleUpdateCart} ref={formRef} />
                )}
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={onClose}>
                    Отмена
                </Button>
                <Button color="primary" variant="contained" onClick={invokeSubmit}>
                    Сохранить
                </Button>
            </DialogActions>
        </>
    );
};

export default CartDialogContext;
